import React from "react";
import PropTypes from "prop-types";

import Header from "../Header";
import PageSection from "../PageSection";

const PageHeader = props => {
    return (
        <React.Fragment>
            <PageSection sectionName="general-header">
                <Header authenticated={props.authenticated} />
                <h1>{props.title}</h1>
                {props.subtitle && (
                    <p className="subtitle">Last updated 4th August 2018</p>
                )}
            </PageSection>
        </React.Fragment>
    );
};

PageHeader.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    authenticated: PropTypes.bool
};

export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/landingPage/PageHeader.jsx